module.exports = __webpack_public_path__ + "img/@work_img8.37a20aaf.jpg";